import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { PaymentStatus } from '../../../constants/constants';

const mutation = gql`
  mutation forceActivateHive($hiveId: String!) {
    forceActivateHive(hiveId: $hiveId) {
      id
      paymentStatus
    }
  }
`;

interface MutationResult {
  forceActivateHive: {
    id: string;
    paymentStatus: PaymentStatus;
  };
}

interface MutationVariables {
  hiveId: string;
}

export function useForceActivateHiveMutation() {
  return useMutation<MutationResult, MutationVariables>(mutation);
}
